import React, { useState, useEffect } from 'react';
import { noticeAPI } from '../../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PageTitle from '../shared/PageTitle';

const AnnouncementForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [expiryDate, setExpiryDate] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isEdit) {
      const fetchAnnouncement = async () => {
        try {
          const response = await noticeAPI.getAnnouncement(id);
          const ann = response.data;
          setTitle(ann.title);
          setDescription(ann.description);
          setStartDate(new Date(ann.start_date));
          setExpiryDate(ann.expiry_date ? new Date(ann.expiry_date) : null);
        } catch (err) {
          console.error('Error fetching announcement:', err);
          setError('Failed to load announcement.');
        }
      };
      fetchAnnouncement();
    }
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedTitle = title.trim();
    const trimmedDescription = description.trim();

    if (!trimmedTitle || !trimmedDescription) {
      setError('Title and description are required and cannot be empty.');
      return;
    }

    const data = {
      title: trimmedTitle,
      description: trimmedDescription,
      start_date: startDate.toISOString(),
      expiry_date: expiryDate ? expiryDate.toISOString() : null,
    };

    try {
      if (isEdit) {
        await noticeAPI.updateAnnouncement(id, data);
      } else {
        await noticeAPI.createAnnouncement(data);
      }
      navigate('/admin/announcements');
    } catch (err) {
      console.error('Error saving announcement:', err);
      setError('Failed to save announcement.');
    }
  };

  const handleDelete = async () => {
    if (isEdit && window.confirm('Are you sure you want to delete this announcement?')) {
      try {
        await noticeAPI.deleteAnnouncement(id);
        navigate('/admin/announcements');
      } catch (err) {
        console.error('Error deleting announcement:', err);
        setError('Failed to delete announcement.');
      }
    }
  };

  return (
    <div className="container-fluid mt-4 activity-container">
      <PageTitle 
        icon="fa-bullhorn" 
        title={isEdit ? 'Edit Announcement' : 'Create New Announcement'} 
        action={
          <button 
            type="button" 
            className="btn btn-outline-secondary" 
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left me-2"></i>Back
          </button>
        }
      />
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value.trimStart())}
                onBlur={(e) => setTitle(e.target.value.trim())}
                
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows="4"
                value={description}
                onChange={(e) => setDescription(e.target.value.trimStart())}
                onBlur={(e) => setDescription(e.target.value.trim())}
                
              />
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Start Date</label>
                  <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Expiry Date (optional)</label>
                  <DatePicker selected={expiryDate} onChange={(date) => setExpiryDate(date)} className="form-control" isClearable />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div>
                <button type="submit" className="btn btn-primary me-2">
                  <i className="fas fa-save me-1"></i>Save
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
                  <i className="fas fa-times me-1"></i>Cancel
                </button>
              </div>
              {isEdit && (
                <button type="button" className="btn btn-danger" onClick={handleDelete}>
                  <i className="fas fa-trash me-1"></i>Delete
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementForm; 